import type { IconSvgObject } from './types';

const SharingIcon: IconSvgObject = [
  ["path", { d: "M15 16C15 17.6569 13.6569 19 12 19C10.3431 19 9 17.6569 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 5H19.9994C20.9422 5 21.4136 5 21.7065 5.29289C21.9994 5.58579 21.9994 6.05719 21.9994 7V9.5M16 11L21.5 5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.49942 5H4C3.05719 5 2.58579 5 2.29289 5.29289C2 5.58579 2 6.05719 2 7V9.5M8 11.0006L2.49942 5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SharingIcon;
